<template>
  <div class="qaList">
    <div class="attentionBox">
      <div class>
        <div class="searchRight">
          <span class="batch" @click="sendFlag">返回</span>
          <div class="box">
            <span>总额度:</span>
            <span class="money">{{ rowData.creditAmount }}</span>
          </div>
          <div class="box">
            <span>剩余额度:</span>
            <span class="money">{{ rowData.balanceAmount }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="账单明细" name="billList" class="sub-main" v-loading="loading">
        <div>
          <div style="display: flex; justify-content: space-between">
            <div>
              <span style="margin-right: 10px; font-size: 16px">还款时间</span>
              <el-date-picker v-model="billform.dates" type="daterange" align="right" unlink-panels format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="pickerOptions"></el-date-picker>
              <el-button type="primary" @click="getBillList(rowData.creditId)">查询</el-button>
              <el-button @click="clear">重置</el-button>
            </div>
            <div class="info">
              <span>{{ rowData.shopName }}</span>
              <span>支出:</span>
              <span>￥ {{ credit.expendAmount }}</span>
              <span>共{{ credit.billCount }}笔</span>
            </div>
          </div>

          <el-table :header-cell-style="{
            background: '#F2F6FC',
            color: '#525A6E',
            height: '40px',
          }" stripe :data="billData" border style="width: 100%" class="mar-top-30">
            <el-table-column label="商品名称" width="300">
              <template slot-scope="scope">
                <img :src="scope.row.image" alt style="width: 50px; margin-right: 10px" />
                <span>{{ scope.row.productName }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="来源订单">
              <template slot-scope="scope">
                <span>{{ scope.row.orderFormid }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="消费时间">
              <template slot-scope="scope">
                <span>{{ scope.row.createDate }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="消费金额">
              <template slot-scope="scope">
                <span style="color: #ff4747">{{ scope.row.billAmount }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="还款状态">
              <template slot-scope="scope">
                <span v-if="scope.row.isPayBack">已还款</span>
                <span v-else style="color:rgb(245, 174, 124);">未还款</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="还款截止时间">
              <template slot-scope="scope">
                <span>{{ scope.row.dueDate }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.state == 1">
                  {{
                  scope.row.stateText
                  }}
                </el-tag>
                <el-tag type="error" v-else-if="scope.row.state == 0">
                  {{
                  scope.row.stateText
                  }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button class="btn" size="small" @click="billItem(scope.row,'order')">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="footerText" style="display: flex; justify-content: right; margin-top: 30px">
            <el-pagination background layout="prev, pager, next" :page-size="billpageSize" :current-page="billpage"
              @current-change="billChangePage" :total="billtotal"></el-pagination>
            <span>全部待还:</span>
            <span class="money">￥{{ credit.payBackAmount }}</span>
            <span>
              (逾期金额:
              <span style="color: #ff4747; font-weight: bold">￥{{ credit.overdueAmount }}</span>
              )
            </span>
            <span class="batch" @click="toBackMaony()">去还款</span>
          </div>
        </div>
        <!-- <div class="nothing sub-main" v-else>
          <img
            class="cur-poi"
            src="../../../../static/image/noorder@2x.png"
            alt=""
          />
          <p class="fs20 font-color-999">您还没有提问～</p>
          <router-link to="/">
            <el-button>去首页看看</el-button>
          </router-link>
        </div>-->
      </el-tab-pane>
      <el-tab-pane label="还款明细" name="tableData" class="sub-main" v-loading="loading">
        <div>
          <div style="display: flex; justify-content: space-between">
            <div>
              <span style="margin-right: 10px; font-size: 16px">还款时间</span>
              <el-date-picker v-model="payBackForm.dates" type="daterange" align="right" unlink-panels
                format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
              <el-button type="primary" @click="getPayBackList(rowData.creditId)">查询</el-button>
              <el-button @click="clear">重置</el-button>
            </div>
            <div class="info">
              <span>{{ rowData.shopName }}</span>
              <span>支出:</span>
              <span>￥ {{ credit.payBackAmount }}</span>
              <span>共{{ credit.billCount }}笔</span>
            </div>
          </div>

          <el-table :header-cell-style="{
            background: '#F2F6FC',
            color: '#525A6E',
            height: '40px',
          }" stripe :data="tableData" border style="width: 100%" class="mar-top-30">
            <el-table-column label="还款时间">
              <template slot-scope="scope">
                <span>{{ scope.row.paybackTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="还款编号">
              <template slot-scope="scope">
                <span>{{ scope.row.paybackNum }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="还款金额">
              <template slot-scope="scope">
                <span style="color: #ff4747">{{ scope.row.paybackPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="支付方式">
              <template slot-scope="scope">
                <span>{{ scope.row.transferCode }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div>
            <el-pagination style="margin-top: 30px" background layout="prev, pager, next" :page-size="payPageSize"
              :current-page="payPage" @current-change="qaChangePage" :total="payTotal"></el-pagination>
          </div>
        </div>
        <!-- <div class="nothing sub-main" v-else>
          <img src="../../../../static/image/noorder@2x.png" alt="" />
          <p class="fs20 font-color-999">您还没有回答～</p>
          <router-link to="/">
            <el-button>去首页看看</el-button>
          </router-link>
        </div>-->
      </el-tab-pane>
      <el-tab-pane label="授权商品" name="shopList" class="sub-main" v-loading="loading">
        <div>
          <div style="display: flex; justify-content: space-between">
            <div>
              <el-input style="width: 300px" placeholder="请输入商品名称" v-model="productName">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <div class="info">
              <span>{{ rowData.shopName }}</span>
              <span>支出:</span>
              <span>￥ {{ credit.payBackAmount }}</span>
              <span>共{{ credit.billCount }}笔</span>
            </div>
          </div>

          <el-table :header-cell-style="{
            background: '#F2F6FC',
            color: '#525A6E',
            height: '40px',
          }" stripe :data="shopData" border style="width: 100%" class="mar-top-30">
            <el-table-column label="商品名称">
              <template slot-scope="scope">
                <span>{{ scope.row.productName }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="账期（天）" width="180px">
              <template slot-scope="scope">
                <span>{{ scope.row.creditDays }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="授权状态" width="180px">
              <template slot-scope="scope">
                <span style="color: #ff4747" v-if="credit.creditState == 0">禁用</span>
                <span style="color: #ff4747" v-if="credit.creditState == 1">已授权</span>
                <span style="color: #ff4747" v-if="credit.creditState == 2">已终止</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="200">
              <template slot-scope="scope">
                <el-button class="btn" size="small" @click="billItem(scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div>
            <el-pagination style="margin-top: 30px" background layout="prev, pager, next" :page-size="pageSize"
              :current-page="page" @current-change="shopChangePage" :total="total"></el-pagination>
          </div>
        </div>
        <!-- <div class="nothing sub-main" v-else>
          <img src="../../../../static/image/noorder@2x.png" alt="" />
          <p class="fs20 font-color-999">您还没有回答～</p>
          <router-link to="/">
            <el-button>去首页看看</el-button>
          </router-link>
        </div>-->
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="确认还款金额" :visible.sync="repaymentDialog" :before-close="handleClose" width="30%">
      <div class="weChatBox" style="justify-content: center; margin: 0 auto; width: 370px">
        <div style="margin-bottom: 20px">
          <span style="font-size: 18px; font-weight: 600">应还:</span>
          <span style="
              font-size: 46px;
              font-weight: 600;
              color: #ff4747;
              margin: 0 20px;
            ">{{ credit.payBackAmount }}</span>
          <span style="font-size: 18px; font-weight: 600">元</span>
          <div @click="toEdit" style="
              font-size: 18px;
              font-weight: 600;
              color: #f77b0b;
              width:50px;
              cursor:pointer;
              margin:10px 0;
            ">修改</div>
          <div v-if="ableEdit">
            <el-input placeholder="请输入还款金额" v-model="payBackAmountEdit" type="number" clearable>
              <template slot="append">元</template>
            </el-input>
          </div>
        </div>
        <div>
          <span style="font-size: 18px; color: #606266">
            <i class="el-icon-warning-outline"></i>温馨提示:单笔最多只能支付5万元
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="repaymentDialog = false">取 消</el-button>
        <el-button type="primary" @click="goPayBack(rowData.creditId)" :loading="payBackLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import { mapGetters } from "vuex";
import { listSearchMixin } from "@/config/mixin";
export default {
  name: "billItem",
  mixins: [listSearchMixin],
  props: ["rowData", "stateFlag"],
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      stateFlag2: true,
      credit: {},
      search: {
        date: "",
        datetype: ""
      },
      options: [
        {
          value: "1",
          label: "近三天"
        },
        {
          value: "2",
          label: "近一周"
        },
        {
          value: "3",
          label: "近一个月"
        }
      ],
      billData: [],
      tableData: [],
      shopData: [],
      repaymentDialog: false,
      activeName: "billList",
      billpage: 1,
      billpageSize: 10,
      billtotal: 0,
      page: 1,
      pageSize: 10,
      total: 0,
      productName: "",
      questionList: [],
      payPage: 1,
      payPageSize: 10,
      payTotal: 0,
      qaList: [],
      current: null,
      flag: true,
      flag1: true,
      edit: false,
      selectAll: 0,
      loading: false,
      billform: {
        dates: []
      },
      payBackForm: {
        dates: [],
        // paybackMode: 0,
        paybackNum: "",
        paybackTime: ""
      },
      credit: {},
      payBackAmountEdit: "",
      ableEdit: false,
      payBackLoading:false
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    console.log(this.rowData);
    console.log(this.stateFlag);
    this.getBillList(this.rowData.creditId);
  },
  methods: {
    toEdit() {
      this.ableEdit = true
    },
    billItem(item, type) {
      if (type == "order") {
        // 跳转到订单详情
        this.$router.push({
          path: "/orderDetail_B2B",
          query: {
            orderId: item.orderId
          }
        });
      } else {
        let data = {
          productId: item.productId,
          skuId: item.skuId,
          shopId: item.shopId
        };
        this.$router.push({
          path: "/productDetail",
          query: {
            proData: JSON.stringify(data)
          }
        });
      }
    },
    sendFlag() {
      this.stateFlag2 = true;
      //func: 是父组件指定的传数据绑定的函数，this.msg:子组件给父组件传递的数据
      this.$emit("func", this.stateFlag2);
    },

    toBackMaony() {
      this.repaymentDialog = true;
    },
    clear() {
      this.payBackForm.dates = [];
      this.billform.dates = [];
    },
    //获取企业账单明细
    getBillList(creditId) {
      let params = {
        url: api.billList,
        method: "post",
        data: {
          creditId: creditId,
          dates: this.billform.dates,
          page: this.billpage,
          pageSize: this.billpageSize
        }
      };
      this.sendReq(params, res => {
        if (res.code === "200") {
          this.credit = res.data.credit;
          this.billData = res.data.list;
          this.billtotal = res.data.total;
        }
      });
    },

    //获取企业授信商品列表
    getShopList(creditId) {
      let params = {
        url: api.shopList,
        method: "post",
        data: {
          creditId: creditId,
          page: this.page,
          pageSize: this.pageSize,
          productName: this.productName
        }
      };
      this.sendReq(params, res => {
        if (res.code === "200") {
          this.shopData = res.data.list;
          this.credit = res.data.credit;
          this.total = res.data.total;
        }
      });
    },
    //获取还款明细列表
    getPayBackList(creditId) {
      let params = {
        url: api.paybackList,
        method: "post",
        data: {
          creditId: creditId,
          dates: this.payBackForm.dates,
          page: this.payPage,
          pageSize: this.payPageSize,
          // paybackMode: 0,
          paybackNum: this.payBackForm.paybackNum,
          paybackTime: this.payBackForm.paybackTime
        }
      };
      this.sendReq(params, res => {
        if (res.code === "200") {
          this.tableData = res.data.list;
          this.credit = res.data.credit;
          this.payTotal = res.data.total;
        }
      });
    },
    //账期还款
    goPayBack(creditId) {
      let params = {}
      if (this.ableEdit) {
        if (this.payBackAmountEdit == "") {
          this.$message({
            message: '请输入修改金额',
            type: "warning",
          });
          return
        }
        if (Number(this.payBackAmountEdit) > this.rowData.payBackAmount) {
          this.$message({
            message: '修改金额不能大于待还金额',
            type: "warning",
          });
          return
        }
        params = {
          url: api.payBack,
          method: "post",
          data: {
            creditId: creditId,
            paybackPrice: Number(this.payBackAmountEdit)
          }
        };
      } else {
        params = {
          url: api.payBack,
          method: "post",
          data: {
            creditId: creditId,
            paybackPrice: this.rowData.payBackAmount
          }
        };
      }
      this.payBackLoading = true
      this.sendReq(params, res => {

        if (res.code === "") {
          this.payBackLoading = false
          // this.$message.success("还款成功");
          this.repaymentDialog = false;
          if (res.data && res.data.payUrl) {
            this.$message({
              message: '即将跳转支付...',
              type: "success",
            });
            setTimeout(() => {
              var a = document.createElement('a');
              a.setAttribute('href', res.data.payUrl);
              a.setAttribute('target', '_blank');
              a.setAttribute('id', "toPay");
              // 防止反复添加
              if (!document.getElementById("toPay")) document.body.appendChild(a);
              a.click();
              // window.location.href = res.data.url
              // window.open(res.data.url)
            }, 2000);
          }
        }
        else {
          this.$message.warning(res.message);
          this.payBackLoading = false
        }
      });
    },
    // 取消还款
    handleClose() {
      let _this = this;
      this.$confirm({
        okText: "确定",
        cancelText: "取消",
        title: "取消还款",
        content: "确认取消还款？",
        onOk() {
          _this.repaymentDialog = false;
        },
        onCancel() {
          // _this.repaymentDialog = false
        }
      });
    },

    handleClick() {
      this.edit = false;
      this.selectAll = 0;
      if (this.activeName === "billList") {
        this.billpage = 1;
        this.getBillList(this.rowData.creditId);
      } else if (this.activeName === "shopList") {
        this.page = 1;
        this.getShopList(this.rowData.creditId);
      } else {
        this.payPage = 1;
        this.getPayBackList(this.rowData.creditId);
      }
    },
    billChangePage(val) {
      this.billpage = val;
      this.getBillList(this.rowData.creditId);
    },
    shopChangePage(val) {
      this.page = val;
      this.getShopList(this.rowData.creditId);
    },
    qaChangePage(val) {
      this.payPage = val;
      this.getPayBackList(this.rowData.creditId);
    },
    seeAll(index) {
      if (this.current === index) {
        this.current = null;
      } else {
        this.current = index;
      }
    },

    toProductDetail(item) {
      let data = {
        shopId: item.shopId,
        productId: item.productId,
        skuId: item.skuId
      };
      this.$router.push({
        path: "/productDetail",
        query: {
          proData: JSON.stringify(data)
        }
      });
    },
    showEdit() {
      this.edit = true;
    },
    changeChecked() {
      if (this.activeName === "billList") {
        this.questionList.map(item => {
          item.selected = this.selectAll;
        });
      } else {
        this.qaList.map(item => {
          item.selected = this.selectAll;
        });
      }
    },
    delFun() {
      let x = false;
      let ids = [];
      if (this.activeName === "billList") {
        this.questionList.map(item => {
          if (item.selected === 1) {
            x = true;
            ids.push(item.problemId);
          }
        });
        if (x === false) {
          return this.$message.warning("请先选择需要删除的提问");
        }
        this.$confirm("此操作将删除选中的回答, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.delProblem(ids);
          })
          .catch(() => { });
      } else {
        this.qaList.map(i => {
          if (i.selected === 1) {
            i.answers.map(j => {
              if (j.name === this.userInfo.name) {
                x = true;
                ids.push(j.answerId);
              }
            });
          }
        });
        if (x === false) {
          return this.$message.warning("请先选择需要删除的回答");
        }
        this.$confirm("此操作将删除选中的回答, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.delAnswer(ids);
          })
          .catch(() => { });
      }
    },
    saveList() {
      this.edit = false;
    },
    selectQu(index, selected) {
      if (selected === 1) {
        this.questionList[index].selected = 0;
      } else {
        this.questionList[index].selected = 1;
      }
      this.selectAll = 1;
      this.questionList.map(item => {
        if (item.selected === 0) {
          this.selectAll = 0;
        }
      });
    },
    selectQa(index, selected) {
      if (selected === 1) {
        this.qaList[index].selected = 0;
      } else {
        this.qaList[index].selected = 1;
      }
      this.selectAll = 1;
      this.qaList.map(item => {
        if (item.selected === 0) {
          this.selectAll = 0;
        }
      });
    },
    delProblem(ids) {
      let params = {
        url: api.delProblem,
        method: "DELETE",
        data: {
          ids: ids
        }
      };
      this.sendReq(params, res => {
        if (res.code === "200") {
          this.$message.success("删除成功");
          this.edit = false;
          this.selectAll = 0;
          this.getSelfProblems();
        }
      });
    },
    delAnswer(ids) {
      let params = {
        url: api.delAnswer,
        method: "DELETE",
        data: {
          ids: ids
        }
      };
      this.sendReq(params, res => {
        if (res.code === "200") {
          this.$message.success("删除成功");
          this.edit = false;
          this.selectAll = 0;
          this.getSelfAnswers();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.footerText {
  .el-pagination {
    margin-right: 50px;
  }

  span {
    height: 32px;
    line-height: 32px;
    font-size: 16px;
    color: #333333;
  }

  .money {
    font-weight: bold;
    color: #ff4747;
    font-size: 22px;
    margin-right: 20px;
  }

  .batch {
    display: inline-block;
    margin-top: -10px;
    margin-left: 30px;
    color: #ffffff;
    font-size: 20px;
    width: 90px;
    border-radius: 4px;
    text-align: center;
    padding: 0 auto;
    height: 50px;
    line-height: 50px;
    background: $mainColor;
    cursor: pointer;
  }
}

.qaList {
  // border: 1px solid #E5E5E5;
  position: relative;

  >>>.el-tabs__nav-wrap::after {
    height: 1px;
  }

  .attentionBox {
    position: absolute;
    top: 15px;
    right: 25px;
    z-index: 99;

    .searchRight {
      display: flex;

      input {
        margin-left: 16px;
        border: 1px solid #e5e5e5;
        padding-left: 10px;
        font-size: 14px;
        width: 175px;
      }

      span {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        font-weight: bold;
      }

      .box {
        margin-left: 40px;

        span {
          height: 30px;
          line-height: 30px;
        }

        .money {
          font-size: 22px;
          font-weight: bold;
          color: #ff4747;
        }
      }

      .batch {
        display: inline-block;
        margin-right: 30px;
        color: #ffffff;
        font-size: 16px;
        width: 70px;
        border-radius: 4px;
        text-align: center;
        padding: 0 auto;
        height: 35px;
        line-height: 35px;
        background: $mainColor;
        // border: 2px solid $mainColor;
        cursor: pointer;
      }

      .searchBtn {
        width: 64px;
        height: 28px;
        line-height: 28px;
        background: #ff7800;
        color: #ffffff;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
      }

      .saveList {
        display: flex;
        align-items: center;

        span {
          margin-left: 36px;
          cursor: pointer;
          color: #333333;
          font-size: 14px;
        }

        span.save {
          width: 78px;
          height: 28px;
          background: #ff7800;
          color: #ffffff;
          text-align: center;
          line-height: 28px;
        }
      }
    }
  }

  >>>.el-tabs__nav-scroll {
    padding: 0 25px;
    height: 60px;
    line-height: 60px;

    .el-tabs__item {
      font-size: 18px;
      color: #333333;
    }

    .is-active {
      color: $mainColor;
    }
  }

  >>>.el-tabs__content {
    padding: 35px 40px;
  }

  .listBox {
    border-top: 1px solid #e5e5e5;
    position: relative;

    .item {
      display: flex;
      justify-content: space-between;
      padding: 25px 0;
      border-bottom: 1px solid #e5e5e5;
      // margin-bottom: 30px;
      position: relative;

      .questionBox {
        display: flex;
        width: 100%;

        img {
          width: 62px;
          height: 62px;
          margin-right: 20px;
        }

        .infoBox {
          font-size: 14px;
          color: #333333;
          width: 100%;

          div {
            // height: 30px;
            // line-height: 30px;
            display: flex;
            justify-content: space-between;

            h3 {
              flex: 1;
            }

            span {
              display: block;
              text-align: right;
            }

            .time {
              font-size: 13px;
              color: #666666;
              margin-bottom: 25px;
              margin-left: 30px;
            }
          }

          ul {
            height: 30px;
            line-height: 30px;
            overflow: hidden;

            li {
              height: 100%;
              display: flex;
              justify-content: space-between;

              .viewDetail {
                font-size: 14px;
                color: $mainColor;
                cursor: pointer;
              }

              .noSee {
                display: none;
              }
            }
          }

          .noReply {
            height: 30px;
            line-height: 30px;
            color: #999999;
          }

          .moreShow {
            height: auto;
          }
        }
      }

      .qaBox {
        display: flex;
        // width: 700px;
        flex: 1;

        img {
          width: 62px;
          height: 62px;
          margin-right: 20px;
        }

        .infoBox {
          font-size: 14px;
          color: #333333;

          h3 {
            margin-bottom: 20px;
          }

          .noReply {
            color: #999999;
          }
        }
      }
    }
  }

  .qaBoxList {
    .item {
      .qaBox {
        .infoBox {
          h3 {
            margin-bottom: 10px;
          }

          .reply {
            margin-bottom: 5px;
          }

          .replyTime {
            font-size: 13px;
            color: #999999;
          }
        }
      }

      .rightBox {
        span {
          display: block;
          text-align: right;
          margin-left: 30px;
        }

        .time {
          font-size: 13px;
          color: #666666;
          margin-bottom: 25px;
        }

        .viewDetail {
          font-size: 14px;
          color: $mainColor;
          cursor: pointer;
        }
      }
    }
  }

  // >>> .el-tabs {
  // }
  .sub-main {
    min-height: 400px;
  }

  .nothing {
    width: 100%;
    text-align: center;
    min-height: 400px;

    p {
      margin-bottom: 20px;
    }

    .el-button {
      background-color: #ff7800;
      color: #ffffff;
      font-weight: normal;
      border-radius: 0;
    }
  }

  .edit:before {
    content: "";
    background: url("./../../../assets/images/noEdit.png");
    width: 58px;
    height: 58px;
    position: absolute;
    right: 0;
    top: 0;
    display: block;
    background-size: contain;
    z-index: 999;
  }

  .selected:before {
    background: url("./../../../assets/images/edit.png");
    background-size: contain;
  }

  .mc {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}

.btn {
  border: 1px solid #e5e5e4 !important;
  font-size: 14px;
  outline: none;
  color: #999999 !important;
}

.info {
  span {
    font-size: 16px;
    height: 40px;
    line-height: 40px;

    &:nth-child(1) {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      margin-right: 50px;
    }

    &:nth-child(3) {
      font-size: 20px;
      font-weight: bold;
      color: #ff4747;
      margin-right: 50px;
    }
  }
}

>>>.el-date-editor .el-range-separator {
  padding: 0 5px;
  line-height: 32px;
  width: 8% !important;
  color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/billPayServer/billItem.vue